import { Pipe, PipeTransform } from '@angular/core';
import { valueIncludes, valueIsEither } from '../helpers/functions.helper';
@Pipe({
  name: 'stringWrappedIn'
})
export class StringWrappedInPipe implements PipeTransform {

  transform(str: string, char:string): any {
    if(!str?.includes(char)) return '';
    let lastIndex = str?.lastIndexOf(char);
    let specials= ['()','{}','[]','<>','--','**','!!','__','++']
    if(valueIsEither(char,specials.map(e=>e?.[0]))) {
      lastIndex = str.lastIndexOf(specials?.find(e => valueIncludes(e,char[0]))?.[1]);
    }
    return str?.substring(str?.indexOf(char)+1,lastIndex);
  }


}
